<template lang="pug">
.loading(v-show="display")
  .loading-msg
    b-spinner.spinner
    span.message.align-self-center {{ message }}
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * ローディング表示コンポーネント
 *
 * ローディングの表示/非表示を切り替える
 */
@Component
export default class Loading extends Vue {
  /** ローディングの表示 */
  public display: boolean = false;
  /** 表示メッセージ */
  public message: string = "";

  /**
   *  vue lifecycle created
   */
  public created(): void {
    return;
  }

  /**
   * ローディング表示
   *
   * @param message コンポーネント配置時に指定したメッセージを上書きする場合に使用
   */
  public show(message: string = ""): void {
    this.message = message;
    this.display = true;
    return;
  }

  /**
   * ローディング非表示
   */
  public hide(): void {
    this.display = false;
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

.loading {
  display: table;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  opacity: 0.8;
  // ローディング表示中にヘッダーやサイドメニューを触らせたいためz-indexを調整
  // ヘッダー:z-index 1000
  // サイドメニュー：z-index 900
  z-index: 800;

  .loading-msg {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    .spinner {
      width: 40px;
      height: 40px;
      margin-right: 12px;
      color: $loading;
    }

    .message {
      @include bold-font(22px);
    }
  }
}
</style>
